import React, {Component} from 'react';
import NumberFormat from 'react-number-format';
import wincalcPopup from '../popup';

import classes from './price.module.scss';
import './price.scss';


export default class Price extends Component{

	wincalcPopupOpen(){
		wincalcPopup.open()
	}

	render(){

		const {currentTypeWindowId, currentProfileId, window_height, window_width, storeOptions, windowsTypeLeaf, currentCountWindows} = this.props.mainstate;
		let {salePercent, saleCountWindow, valute}  = this.props.mainstate;
		const {...itemTypeProfile} = this.props.profiledata;
		const {typewindowdata, pricefurnitura} = this.props;

		const idxCurrentTypeWindowId = typewindowdata.findIndex((el) => el.id === currentTypeWindowId),
			  idxCurrentProfileId = this.props.profiledata.findIndex((el) => el.id === currentProfileId);

		const price = itemTypeProfile[idxCurrentProfileId].price[idxCurrentTypeWindowId];

		const idx = 4, // индекс ячейки в объекте typeWindowData, где находятся данные о Балконе
			  WIDTH_DOOR = typewindowdata[idx].widthDoor,
			  HEIGHT_REST = typewindowdata[idx].heightRest;

		let area = window_height * window_width / 1000000;
		const areaDoor = WIDTH_DOOR * window_height / 1000000;


		let cost = 0,
			priceWindow = 0,
			priceFurniture = 0,
			priceMontage = 0,
			priceOptions = 0,
			priceDoor = 0;

		switch (currentTypeWindowId){
			case 5:
					// Если выбран балкон
					salePercent = 0;
					const balkon_window_width = window_width - WIDTH_DOOR,
						  areaRest = HEIGHT_REST * balkon_window_width / 1000000;
					const areaWin = area - areaDoor - areaRest;

					priceWindow = itemTypeProfile[0].price[1] * areaWin;
					priceFurniture = this.calcFurntiture((window_height - HEIGHT_REST), windowsTypeLeaf, currentCountWindows, pricefurnitura);
					priceDoor = WIDTH_DOOR * window_height * price/ 1000000;
					priceMontage = this.calcMontage(areaWin, storeOptions) + this.calcMontage(areaDoor, storeOptions);
					priceOptions = this.calcOptions(window_width, window_height, balkon_window_width,windowsTypeLeaf, currentCountWindows,  storeOptions);
				break;
			default:
					priceWindow = price * area;
					priceFurniture = this.calcFurntiture(window_height, windowsTypeLeaf, currentCountWindows, pricefurnitura);
					priceMontage = this.calcMontage(area, storeOptions);
					priceOptions = this.calcOptions(window_width, window_height, 0 , windowsTypeLeaf, currentCountWindows, storeOptions);
				break;
		}


		cost = (priceWindow + priceFurniture)*saleCountWindow*(1 - salePercent/100) + priceMontage + priceOptions + priceDoor;

		return (
			<div className={classes['wincalc-price'] + [' wincalc-widget'] }>
				<div className="d-md-flex justify-content-center">
					<div className="price-block">
						<p>приблизительная стоимость вашего окна</p>
						<p className={classes['sum']}>
							<NumberFormat
								value={cost.toFixed()}
								displayType={'text'}
								thousandSeparator={' '}
								prefix={''}
							/> {valute}
						</p>
					</div>
					<button type="button" className="wincalc-button" onClick={this.wincalcPopupOpen}>Связь с менеджером</button>
				</div>
			</div>
		)
	}

	// CUSTOM FUNCTION
	calcFurntiture = ( window_height, windowsTypeLeaf, currentCountWindows, pricefurnitura) => {
		let calcprice = 0;
		const resizeStoreOptions = windowsTypeLeaf.slice(0, currentCountWindows);
		// находим поворотные и откидные
		let po = resizeStoreOptions.filter(el => el==='p' || el==='o');

		po.forEach(el => {
			switch(true){
				case (window_height > 700 && window_height <= 1000) :
					calcprice += pricefurnitura[el][1];
					break;
				case (window_height > 1000 && window_height <= 1100) :
					calcprice += pricefurnitura[el][2];
					break;
				case (window_height > 1100 && window_height <= 1300) :
					calcprice += pricefurnitura[el][3];
					break;
				case (window_height > 1300 && window_height <= 1400) :
					calcprice += pricefurnitura[el][4];
					break;
				case (window_height > 1400 && window_height <= 1600) :
					calcprice += pricefurnitura[el][5];
					break;
				case (window_height > 1600 && window_height <= 1800) :
					calcprice += pricefurnitura[el][6];
					break;
				case (window_height > 1800 && window_height <= 2000) :
					calcprice += pricefurnitura[el][7];
					break;
				case (window_height > 2000) :
					calcprice += pricefurnitura[el][8];
					break;
				default:
					calcprice += pricefurnitura[el][0];
					break;
			}
		});

		return calcprice;
	}

	calcMontage = (area, storeOptions) => {
		const arrMontage = [...storeOptions].filter(el => el.check && el.label.toLowerCase() === 'монтаж');
		const calcprice = (arrMontage.length > 0) ? arrMontage[0]['price'] * area : 0;
		return Number(calcprice);
	}

	calcOptions = (window_width, window_height, balkon_window_width, windowsTypeLeaf, currentCountWindows, storeOptions) => {
		let  calcprice = 0;

		storeOptions.filter(el => el.check).forEach( el => {
			const {label, price} = el;

			switch (label.toLowerCase()){
				case 'подоконник':
					calcprice += Number(price * window_width / 1000);
					break;
				case 'отлив':
					const width = balkon_window_width || window_width;
					calcprice += Number(price * width / 1000);
					break;
				case 'откосы':
					calcprice += Number((2 * window_height + window_width) / 1000 * price);
					break;
				case 'москитная сетка':
					// calcprice += price * currentCountWindows ;
// console.log(windowsTypeLeaf);
					const resizeStoreOptions = windowsTypeLeaf.slice(0, currentCountWindows);
					// находим поворотные и откидные
					let po = resizeStoreOptions.filter(el => el==='p' || el==='o');
					po.forEach(el => calcprice += price)

					break;
				default:
					break;
			}
		});

		return parseInt(calcprice.toFixed());
	}
	// CUSTOM FUNCTION
}


